<template>
  <div class="container_box">
    <!--tab栏区域-->
    <Tabs v-model="ymsCoreStatus" :animated="false" class="tabs_styles" @on-click="changeTab"
      :class="fixedTalg ? 'fixed_box_style' : ''" :style="tabStyles()">
      <TabPane v-for="item in orderTabTypeList" :label="renderLabel(item)" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box" ref="filterBox">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter_1"
              inputType="textarea"
              :selectStyle="{width: '120px'}"
              :dropDownInputList="dropDownInputList_1"
              :defaultSelectValue="defaultSelectValue_1"
              @changeInput="(val)=>changeInput(val, '_1')"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              :transfer="false"
              ref="dropDownFilter_2"
              inputType="textarea"
              :selectStyle="{width: '120px'}"
              :dropDownInputList="dropDownInputList_2"
              :defaultSelectValue="defaultSelectValue_2"
              @changeInput="(val)=>changeInput(val, '_2')"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004501')" prop="ymsPackageTagIds">
              <Select v-model="pageParams.ymsPackageTagIds" multiple>
                <Option v-for="item in ymsOrderLabelData" :key="item.ymsPackageTagId" :value="item.ymsPackageTagId">{{ item.tagName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownDateTime
              :transfer="false"
              ref="dropDownDateTime"
              :dropDownTimeList="dropDownTimeList"
              :defaultSelectValue="defaultSelectTimeValue"
              @changeInput="changeTimeInput"
              @selectTime="selectTime"
              @resetTime="resetTime">
            </dropDownDateTime>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1004502')" prop="carrierStatuList">
              <Select v-model="pageParams.carrierStatuList" filterable>
                <Option v-for="item in carrierStatusList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <div class="flex align-items-center">
              <Select v-model="selectValue" @on-change="changeInputValue" style="width: 120px;">
                <Option v-for="item in logisticsScreeningList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
              <div class="ml6 wid100P">
                <!-- YMS物流-->
                <Cascader
                  ref="cascaderDom"
                  class="wid100P"
                  v-if="selectValue === 1"
                  v-model="shippingMethodModel"
                  :load-data="loadData"
                  @on-change="changeShippingMethod"
                  :data="shippingMethodData"
                  filterable
                  change-on-select>
                </Cascader>
                <!-- 供应商自有物流-->
                <Cascader
                  ref="cascaderDom"
                  class="wid100P"
                  v-else
                  v-model="shippingMethodModel"
                  :load-data="supplierLoadData"
                  @on-change="changeShippingMethod"
                  :data="shippingMethodData"
                  filterable
                  change-on-select>
                </Cascader>
              </div>
            </div>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="`${configCharacters(false)}` + 'SKU：'" prop="ymsSkus">
              <Input type="textarea" :placeholder="$t('key1000324')+ `${configCharacters(false)}` +$t('key1004499')" v-model.trim="pageParams.ymsSkus"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="`${configCharacters(false)}` + 'SPU：'" prop="ymsSpus">
              <Input type="textarea" :placeholder="$t('key1000324')+ `${configCharacters(false)}` +$t('key1004500')" v-model.trim="pageParams.ymsSpus"></Input>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <FormItem :label="$t('key1004503')" prop="orderType">
              <Select v-model="pageParams.orderType" filterable>
                <Option v-for="item in orderTypesList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <FormItem :label="$t('key1004504')" prop="source">
              <Select v-model="pageParams.source" filterable>
                <Option v-for="item in sourceList" :key="item.value" :value="item.value">{{ item.title }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <FormItem :label="$t('key1004389')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <FormItem :label="$t('key1004505')" prop="performanceParty">
              <Select v-model="pageParams.performanceParty">
                <Option v-for="item in performancePartyList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter && platformSelfOperatedProduct">
            <FormItem :label="$t('key1004506')" prop="isSelfOperated" :label-width="160">
              <Select v-model="pageParams.isSelfOperated">
                <Option v-for="item in isSelfOperatedList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol" v-show="moreFilter">
            <FormItem :label="$t('key1004363')">
              <local-tabButton :tabButtonList="abnormalStatusList" @selectStatus="abnormalStatusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col :xxl="twoItemCol" v-show="moreFilter">
            <FormItem :label="$t('key1001575')">
              <local-tabButton :tabButtonList="labelTypeData" @selectStatus="labelTypeStatus"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
        <Row type="flex" justify="end" :gutter="gutterItem">
          <Col style="text-align: right;">
            <Button size="small" @click="toggleMoreFilter">{{ moreFilterMes }}
              <Icon :type="moreFilterIcon" size="small"></Icon>
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <div class="flex align-items-center justify-content-between wid100P">
        <div class="flex align-items-center">
          <!--添加标签-->
          <Button class="mr15" type="primary" v-if="getPermission('ymsPackageInfo_addTagOrRemark')" @click="addTagsBtn('all')">{{ $t('key1001443') }}</Button>
          <!--下发物流-->
          <Button class="mr15" type="primary" @click="distributionLogisticsBtn" :disabled="distributionLogisticsTalg"
            v-if="getPermission('ymsPackageInfo_uploadLogistics')">
            {{ $t('key1004533') }}
          </Button>
          <!--修改物流方式-->
          <Button type="primary" class="modify_styles mr15" @click="modifyMailFn" v-if="getPermission('ymsPackageInfo_updateCarrierInfo')">
            <div class="flex align-items-center">
              <p>{{ $t('key1004281') }}</p>
              <Tooltip transfer placement="top" max-width="600" :content="$t('key1004507')">
                <Icon class="help_icon" size="20" type="md-help-circle"></Icon>
              </Tooltip>
            </div>
          </Button>
          <!--导出数据-->
          <Dropdown transfer class="mr15" @on-click="changeExportBtn" v-if="getPermission('ymsPackageInfo_exportYmsPackageInfo')">
            <Button type="primary">
              <span>{{ $t('key1003082') }}</span>
              <Icon type="ios-arrow-down"></Icon>
            </Button>
            <DropdownMenu slot="list">
              <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
              <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <!--实重导入-->
          <Button class="mr15" type="primary" @click="$refs.commonImport.importModal = true">{{ $t('key1004510') }}</Button>
        </div>
        <div>
          <!--字段排序-->
          <Button-group>
            <Button :type="item.checked ? 'primary' : 'default'" v-for="item in sortData" @click="clickSortButton(item)" :key="item.value">
              <span>{{ item.label }}</span>
              <Icon type="md-arrow-up" v-if="item.checked && !item.toogle"></Icon>
              <Icon type="md-arrow-down" v-if="item.checked && item.toogle"></Icon>
            </Button>
          </Button-group>
        </div>
      </div>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <div ref="tableHeaderWrap" class="table_header_wrap" :style="tableHeaderWrapStyle">
        <Row class="table_header_box" :class="fixedTableTitleTalg ? 'fixed_table_header_box_style' : ''" :style="tableTitleStyles()">
          <Col class="title" v-for="(item,index) in tableColumns" :span="item.span"
            :class="index === 0 ? 'pl20' : ''">{{ item.name }}
          </Col>
          <Checkbox :disabled="tableData.length <=0" class="select_table_box" v-model="selectAllTable" @on-change="allTableChange"></Checkbox>
        </Row>
      </div>
      <!--暂无数据-->
      <div class="no_classify" v-if="tableData.length <=0">
        <img :src="noContent" width="250" height="250" :alt="$t('key1000104')">
      </div>
      <template v-else>
        <Row class="table_box_item" v-for="(item,index) in tableData" :key="index">
          <!--表头区域-->
          <div class="table_content_header_box">
            <Checkbox class="mr8" v-model="item.tableChecked" @on-change="tableChange"></Checkbox>
            <!--订单状态-->
            <Tag color="primary">{{ item.orderStatusText }}</Tag>
            <Tooltip max-width="300" placement="top" class="mr5 cursor" style="position: relative; left:-6px;"
              transfer v-if="item.ymsCoreStatus === 10" :content="item.invalidReason">
              <Icon size="17" type="md-help-circle"/>
            </Tooltip>
            <!--订单编号-->
            <span class="font-weight-bold color-333">{{ $t('key1004534') }}</span>
            <span class="themeColor cursor font-weight-bold" @click="toOrderDetails(item)">{{ item.packageCode }}</span>
            <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor mr10" :title="$t('key1000003')"
              @click="commonCopyContentFun(item.packageCode)"/>
            <!--Temu标签-->
            <Tag v-if="item.temuLabelName" color="blue" class="mr10">{{ item.temuLabelName }}</Tag>
            <!--订单标签-->
            <Tag v-if="item.orderLabelName" color="volcano" class="mr10">{{ item.orderLabelName }}</Tag>
            <!--SKU数量-->
            <span class="ml40 font-weight-bold color-333">{{ $t('key1000601') + (item.skuQuantity || 0) }}</span>
            <!--物品数量-->
            <span class="ml40 font-weight-bold color-333">{{ $t('key1004511') + (item.productQuantity || 0) }}</span>
            <!--异常状态-->
            <span class="ml40 font-weight-bold color-333">{{ $t('key1004363') }}</span>
            <span :class="item.abnormalStatus === 2 ? 'redColor' : 'font-weight-bold color-333'">{{ item.abnormalStatusText }}</span>
            <!--分销商-->
            <span class="ml40 font-weight-bold color-333">{{ $t('key1004345') + (item.distributorMerchantId || '-') }}</span>
            <!--分销商订单号-->
            <span class="ml40 font-weight-bold color-333">{{ $t('key1004388') + (item.orderShippingId || '-') }}</span>
            <!--订单创建时间-->
            <span class="ml40 mr8 font-weight-bold color-333">{{ $t('key1001180') + (formatTime(item.createdTime)) }}</span>
            <Tooltip max-width="300" placement="top" class="mr20" transfer>
              <template #content>
                <p>{{ $t('key1004512') + (formatTime(item.updatedTime)) }}</p>
                <p>{{ $t('key1004513') + (formatTime(item.createdTime)) }}</p>
                <p>{{ $t('key1004514') + (formatTime(item.shipedTime)) }}</p>
                <p v-if="item.status === 8">{{ $t('key1004515') + (formatTime(item.cancelledTime)) }}</p>
              </template>
              <Icon type="ios-more" color="#2D8CF0" class="cursor mr15" size="20"/>
            </Tooltip>
          </div>
          <!--列表内容区域-->
          <div class="table_content_box">
            <!--订单货品信息区域-->
            <div class="orderGoods_box" v-viewer="viewerConfig">
              <div class="flex commodityInfo_box" v-for="(ele,idx) in (item.ymsPackageGoods || []).slice(0, 5)">
                <div class="img_box">
                  <img
                    :src="setImgPath(ele.primaryImage, null, '70x70', null, true)"
                    :data-original="setImgPath(ele.primaryImage, null, null, null, false)"
                    @error="setErrorImg($event)" alt="">
                </div>
                <div class="ml10">
                  <div class="flex align-items-center">
                    <div class="flex flex-wrap align-items-center width_220">
                      <Tag color="primary" class="font-size-12 mr8 width_65" v-if="ele.isSelfOperated === 1">{{ $t('key1004308') }}</Tag>
                      <p class="themeColor cursor mb2 ellipsis_2 flex_1" :title="ele.name" @click="toGoodsDetails(ele)">{{ ele.name }}</p>
                    </div>
                    <span class="width_90 text-align-center color-333">{{ amountHandel(ele.productGoodsCost) + ' ' + item.totalPriceCurrency }}</span>
                    <span class="width_40 text-align-center color-333">{{ ele.quantity }}</span>
                  </div>
                  <p class="flex mb2">
                    <span>{{ configCharacters(false) + 'SPU：' + ele.ymsSpu }}</span>
                    <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor mr10" :title="$t('key1000003')"
                      @click="commonCopyContentFun(ele.ymsSpu)"/>
                  </p>
                  <p class="flex mb2">
                    <span>{{ configCharacters(false) + 'SKU：' + ele.ymsSku }}</span>
                    <Icon type="ios-copy-outline" size="18" color="#01a6ee" class="ml4 cursor mr10" :title="$t('key1000003')"
                      @click="commonCopyContentFun(ele.ymsSku)"/>
                  </p>
                  <p>{{ ele.specifications }}</p>
                  <div v-if="ele.isNeedCustomization === 1" class="flex align-items-center mt2">
                    <span class="themeColor">{{ $t('key1004307') + ele.originalYmsSku }}</span>
                    <Tooltip max-width="450" placement="top" transfer :content="$t('key1004306')">
                      <Icon type="md-alert" color="#2D8CF0" class="cursor ml5 themeColor" size="17"/>
                    </Tooltip>
                  </div>
                </div>
                <span class="goods_box_btn" v-if="item.ymsPackageGoods.length >5 && idx >=4"
                  @click="$refs['orderProduct'].initOrderProductData(item)">
                  {{ $t('key1004516') + $t('key1004517') + (item.ymsPackageGoods.length - 5) + $t('key1004518') }}
                </span>
              </div>
            </div>
            <!--订单信息区域-->
            <div class="flex_1 flex flex-wrap">
              <!--订单金额-->
              <div class="pt12 pr12 pb12 pl9 width_200">
                <div class="flex align-items-center mb5">
                  <p class="color-333">{{ $t('key1004340') + (formatCurrency(item.totalPrice) + ' ' + item.totalPriceCurrency) }}</p>
                  <Icon type="md-create" size="18" color="#01a6ee" v-if="item.payStatus === 1"
                    @click="$refs['orderAmountModification'].initOrderAmountModificationData(item)"
                    class="cursor ml6" style="position: relative; top: -2px;"/>
                </div>
                <!--国内快递费-->
                <div class="flex align-items-center mb5" v-if="orderAmountHandel(item, 6, true)">
                  <p class="color-333">{{ $t('key1004519') + orderAmountHandel(item, 6) }}</p>
                  <Tooltip max-width="450" placement="top" transfer :content="$t('key1004508')">
                    <Icon type="md-help-circle" color="#2D8CF0" class="cursor ml5" size="17"/>
                  </Tooltip>
                </div>
                <template v-if="item.payStatus === 1">
                  <p class="mb5 color-333" v-if="item.totalSuggestPrice > 0">
                    {{ $t('key1004520') + (formatCurrency(item.totalSuggestPrice) + ' ' + item.totalPriceCurrency) }}
                  </p>
                  <p class="mb5 color-333" v-if="item.prepayPackageHandlerCost > 0">
                    {{ $t('key1004521') + (formatCurrency(item.prepayPackageHandlerCost) + ' ' + item.totalPriceCurrency) }}
                  </p>
                  <p class="mb5 color-333" v-if="item.packageHandlerCost > 0">
                    {{ $t('key1004522') + (formatCurrency(item.packageHandlerCost) + ' ' + item.totalPriceCurrency) }}
                  </p>
                </template>
                <template v-else>
                  <p class="mb5 color-333" v-if="orderAmountHandel(item, 1, true)">{{ $t('key1004520') + orderAmountHandel(item, 1) }}</p>
                  <p class="mb5 color-333" v-if="orderAmountHandel(item, 15, true, true)">{{ $t('key1004521') + orderAmountHandel(item, 15) }}</p>
                  <p class="mb5 color-333" v-if="orderAmountHandel(item, 2, true)">{{ $t('key1004522') + orderAmountHandel(item, 2) }}</p>
                </template>
                <div v-if="item.ymsLogisServiceId">
                  <p class="mb5 color-333" v-if="orderAmountHandel(item, 10, true, true)">{{ $t('key1004523') + orderAmountHandel(item, 10) }}</p>
                  <p class="mb5 color-333" v-if="!orderAmountHandel(item, 10, true)">
                    {{ $t('key1004524') + item.prepaidLogisticsFees }}
                  </p>
                </div>
                <div v-else>
                  <template v-if="item.payStatus === 1">
                    <p class="mb5 color-333" v-if="item.estimateFreight >0">{{ $t('key1004523') + (formatCurrency(item.estimateFreight) + ' ' + item.totalPriceCurrency) }}</p>
                  </template>
                  <template v-else>
                    <p class="mb5 color-333">
                      {{
                        $t('key1004523') + (orderAmountHandel(item, 4, true, true) ? orderAmountHandel(item, 4) :
                          orderAmountHandel(item, 9, true, true) ? orderAmountHandel(item, 9) : '-')
                      }}
                    </p>
                  </template>
                </div>
                <p class="mb5 color-333" v-if="orderAmountHandel(item, 7, true)">{{ $t('key1004525') + orderAmountHandel(item, 7) }}</p>
                <p class="mb5 color-333" v-if="orderAmountHandel(item, 11, true)">{{ $t('key1004526') + orderAmountHandel(item, 11) }}</p>
                <p class="mb5 color-333" v-if="orderAmountHandel(item, 12, true)">{{ $t('key1004527') + orderAmountHandel(item, 12) }}</p>
                <p class="mb5 color-333" v-if="orderAmountHandel(item, 13, true)">{{ $t('key1004528') + orderAmountHandel(item, 13) }}</p>
                <p class="mb5 color-333" v-if="orderAmountHandel(item, 14, true)">{{ $t('key1004529') + orderAmountHandel(item, 14) }}</p>
              </div>
              <!--物流信息-->
              <div class="pt12 pr12 pb12 pl9 width_333">
                <div class="flex flex-wrap mb5">
                  <span class="color-333">{{ $t('key1004502') + item.processIssueStatusText }}</span>
                  <span v-if="item.waitHandUploadLogistics === 1" style="color: #FF7D00">{{ $t('key1004535') }}</span>
                  <Tooltip max-width="500" placement="top" transfer :content="getFailureContent(item.carrierErrorMsg)" v-if="item.processIssueStatusTalg">
                    <Icon type="md-information-circle" color="red" class="cursor ml5" size="16"/>
                  </Tooltip>
                </div>
                <div class="flex flex-wrap mb5">
                  <p class="color-333">
                    <span>{{ $t('key1004010') }}</span>
                    <span class="TiktokCBT_box" v-if="item.performanceType === 2">Tiktok-CBT</span>
                    <span>{{ formatCarrierInfo(item) }}</span>
                  </p>
                  <span v-if="!item.shippingMethodId" style="color: #FF7D00">{{ $t('key1004536') }}</span>
                </div>
                <div class="flex flex-wrap align-items-center mb5">
                  <!-- 运单号：等待获取 / 获取失败 / 正常展示 -->
                  <p v-if="getTrackingNumberDisplayType(item) === 'waiting'">
                    <span class="color-333">{{ $t('key1001521') }}</span>
                    <span class="themeColor">{{ $t('key1004537') }}</span>
                  </p>
                  <template v-else-if="getTrackingNumberDisplayType(item) === 'failed'">
                    <p>
                      <span class="color-333">{{ $t('key1001521') }}</span>
                      <span style="color: red">{{ $t('key1004538') }}</span>
                    </p>
                    <Icon
                      :title="$t('key1004509')"
                      type="md-refresh-circle"
                      size="18"
                      color="#2D8CF0"
                      class="cursor ml5"
                      @click="manualGetTrackingNumber(item)"
                    />
                  </template>
                  <p v-else class="color-333">{{ $t('key1001521') + (item.trackingNumber || '-') }}</p>
                  <span v-if="item.carrierStatus === 13 && item.carrierMerchantType !== 1"
                    class="cursor themeColor ml5" @click="downloadTheWaybill(item)">{{ $t('key1004539') }}</span>
                  <!--添加、更新承运商-->
                  <Icon v-if="getPermission('systemTrackingMoreCarrier_query')"
                    :type="item.trackCarrierCode ? 'md-refresh-circle' : 'md-add'"
                    size=18 color="#2D8CF0" class="cursor ml5" @click="carrierBtn(item)">
                  </Icon>
                  <!--查看跟踪轨迹信息-->
                  <Icon v-if="getPermission('ymsPackageInfo_searchLogisticsTracking') && item.trackCarrierCode"
                    type="md-flag" size=18 color="#2D8CF0" class="cursor ml5"
                    @click="$refs['trackingInfo']['getPackageLogisticsTracking'](item.ymsPackageId)">
                  </Icon>
                  <!--修改运单号-->
                  <Icon v-if="getPermission('ymsPackageInfo_modifyCarrierMessage') && item.ymsLogisServiceId && item.status === 7"
                    type="md-create" size=18 color="#2D8CF0" class="cursor ml5"
                    @click="$refs['modifyWaybillNumber']['initModifyWaybillNumberData'](item)">
                  </Icon>
                </div>
                <p class="mb5 color-333">{{ $t('key1004394') + (item.thirdPartyNo || '-') }}</p>
                <p class="mb5 color-333">{{ $t('key1004404') + (userInfo.merchantId + (item.carrierThirdNo || '-')) }}</p>
                <p class="mb5 color-333">{{ $t('key1004530') + (item.selfDeliveryTrackingNumber || '-') }}</p>
              </div>
              <!--发货信息-->
              <div class="pt12 pr12 pb12 pl9 width_266">
                <p class="flex flex-wrap mb5">
                  <span class="color-333">{{ $t('key1004389') + item.deliveryWarehouseName }}</span>
                  <span class="ml2" style="color: #FF7D00" v-if="item.originalWarehouseName">{{ item.originalWarehouseName }}</span>
                </p>
                <p class="mb5 color-333">{{ $t('key1001575') + (item.shippingMethodName || '-') }}</p>
                <p class="mb5 color-333">{{ $t('key1002493') + (item.buyerCountryCode || '-') }}</p>
                <p class="mb5 color-333">{{ $t('key1004531') + (item.customerSelectedLogisticsName || '-') }}</p>
              </div>
              <!--供应商子单信息-->
              <div class="p12 width_133">
                <div class="flex flex-wrap mb5">
                  <p class="color-333">{{ $t('key1002454') + (item.subPackageInfoCount || 0) + $t('key1004532') }}</p>
                  <Tag v-if="item.subPackageGoodsStatusName" color="red">{{ item.subPackageGoodsStatusName }}</Tag>
                </div>
                <p class="mb5 color-333">{{ $t('key1003343') + item.supplierMerchantIds.join('、') }}</p>
                <p class="themeColor cursor" @click="viewSubOrdersBtn(item.ymsPackageId)">{{ $t('key1004540') }}</p>
              </div>
              <!--备注-->
              <div class="p12 width_133">
                <div v-for="(ele, idx) in getRemarkList(item)" :key="idx">
                  <Tooltip max-width="400" placement="top" :content="ele.content" transfer>
                    <p class="ellipsis_1">{{ ele.content }}</p>
                  </Tooltip>
                </div>
                <span v-if="item.remarkList.length >3" class="themeColor cursor" @click="showMoreRemark(index, item.viewRemarkMoreTalg)">
                  {{ item.viewRemarkMoreTalg ? $t('key1000141') : $t('key1000022') }}
                </span>
              </div>
              <!--操作-->
              <div class="pt12 pb12 width_80">
                <!--打印物流面单-->
                <p class="themeColor cursor mb5" v-if="item.labelPath" @click="commonPrint(item.labelPath, item.packageCode)">{{ $t('key1004541') }}</p>
                <!--通知分销商-->
                <p class="themeColor cursor mb5" v-if="item.carrierStatus === 3 && item.isNotifyDistributor === 0"
                  @click="notifyDistributorsBtn(item.ymsPackageId)">{{ $t('key1004542') }}</p>
                <!--允许取消-->
                <p class="themeColor cursor mb5" v-if="shoWallowCancellation(item)" @click="allowCancellationBtn(item)">{{ $t('key1001064') }}</p>
                <!--取消订单-->
                <p class="themeColor cursor mb5" v-if="showCancelOrder(item)" @click="cancelOrderBtn(item)">{{ $t('key1004290') }}</p>
                <!--查看定制信息-->
                <p class="themeColor cursor mb5" v-if="item.isNeedCustomization === 1 && item.status !== 8"
                  @click="$refs['viewCustomizedInfo'].initViewCustomizedInfoData(item)">{{ $t('key1001525') }}</p>
                <!--打印合规标签-->
                <p class="themeColor cursor mb5" v-if="item.isProductLabelPath === 1 && orderComplianceLabelVerificationTalg"
                  @click="$refs['printComplianceLabels'].initPrintComplianceLabelsData(item)">{{ $t('key1000323') }}</p>
                <!--添加标签-->
                <p class="themeColor cursor mb5" v-if="!item.ymsPackageTagIds && getPermission('ymsPackageInfo_addTagOrRemark')"
                  @click="addTagsBtn('single',item.ymsPackageId)">{{ $t('key1001443') }}</p>
                <!--删除标签-->
                <p class="themeColor cursor mb5" v-if="item.ymsPackageTagIds && getPermission('ymsPackageInfo_deleteTag')"
                  @click="deleteATapBtn(item.ymsPackageId,item.ymsPackageTagIds)">{{ $t('key1001444') }}</p>
                <!--添加备注-->
                <p class="themeColor cursor mb5" v-if="getPermission('ymsPackageInfo_addTagOrRemark')"
                  @click="$refs['addOrderTags'].initAddOrderTagsData([item.ymsPackageId], 'remark')">{{ $t('key1002015') }}</p>
                <!--物流费补收-->
                <p class="themeColor cursor mb5" v-if="item.status === 7 && item.ymsLogisServiceId"
                  @click="$refs['logisticsFeeReimbursement'].initLogisticsFeeReimbursementData(item.ymsPackageId)">{{ $t('key1004270') }}</p>
                <!--日志-->
                <p class="themeColor cursor" @click="$refs['commonLog'].initCommonLogData(item.ymsPackageId)">{{ $t('key1002478') }}</p>
              </div>
            </div>
          </div>
        </Row>
      </template>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--跟踪轨迹信息弹窗-->
    <trackingInfoModal ref="trackingInfo"></trackingInfoModal>
    <!--承运商弹窗-->
    <carrierModal ref="carrierInfo" @selectionData="selectionData" :modalTitle="modalTitle"></carrierModal>
    <!--批量修改物流方式-->
    <modifyMailingMethodModal ref="modifyMailingMethod" :packageData="packageData" @getList="search"></modifyMailingMethodModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1000792')+`${configCharacters()}`+$t('key1001887')"
      paramKeyColums="ymsCorePackageInfoExportColumns"
      :dimensionTypeList="dimensionTypeList"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--修改运单号弹窗-->
    <modifyWaybillNumberModal ref="modifyWaybillNumber" @updateData="updateTableData"></modifyWaybillNumberModal>
    <!--已装箱状态允许取消订单确认弹窗-->
    <allowCancellationOfOrdersModal ref="allowCancellationOfOrders" @updateData="updateTableData"></allowCancellationOfOrdersModal>
    <!--取消订单弹窗-->
    <cancelOrderModal ref="cancelOrder" @cancelOrderSuccess="updateTableData"></cancelOrderModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG', 'SUPPLIER_LOG']"></commonLogModal>
    <!--添加标签、备注弹窗-->
    <addOrderTagsModal ref="addOrderTags" :ymsOrderLabelData="ymsOrderLabelData" @updateData="updateTableData"></addOrderTagsModal>
    <!--订单金额修改弹窗-->
    <orderAmountModificationModal ref="orderAmountModification" @updateData="updateTableData"></orderAmountModificationModal>
    <!--查看定制内容弹窗-->
    <viewCustomizedInfoModal ref="viewCustomizedInfo"></viewCustomizedInfoModal>
    <!--取消定制商品订单弹窗-->
    <cancelCustomizedProductOrdersModal
      ref="cancelCustomizedProductOrders"
      @cancelOrderSuccess="updateTableData">
    </cancelCustomizedProductOrdersModal>
    <!--打印合规标签弹窗-->
    <printComplianceLabelsModal ref="printComplianceLabels"></printComplianceLabelsModal>
    <!--实重导入弹窗-->
    <commonImportModal
      :modalWidth="700"
      ref="commonImport"
      :importTitle="$t('key1004510')"
      importType="realWeightImport"
      :importFormat="importFormat"
      fileName="files"
      :promptPush="1"
      :uploadAction="uploadZoneExcel"
      @uploadSuccess="updateTableData"
      importTemplateKey="packageWeight">
      {{ $t('key1002622') }}<br/>
      {{ $t('key1004543') }}<br/>
      {{ $t('key1004544') }}<br/>
      {{ $t('key1004545') }}
    </commonImportModal>
    <!--物流费补收弹窗-->
    <logisticsFeeReimbursementModal
      ref="logisticsFeeReimbursement"
      @updateData="updateTableData">
    </logisticsFeeReimbursementModal>
    <!--订单商品弹窗-->
    <orderProductModal ref="orderProduct"></orderProductModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import trackingInfoModal from "@/components/common/trackingInfoModal";
import carrierModal from "@/components/common/carrierModal";
import ModifyMailingMethodModal from "@/views/yms/components/orderList/modifyMailingMethodModal.vue";
import dropDownFilter from "@/components/common/dropDownFilter";
import api from '@/api/';
import exportFieldsModal from "@/components/common/exportFieldsModal";
import dropDownDateTime from "@/components/common/dropDownDateTime";
import modifyWaybillNumberModal from "@/views/yms/components/orderList/modifyWaybillNumberModal.vue";
import allowCancellationOfOrdersModal from "@/views/yms/components/orderList/allowCancellationOfOrdersModal.vue";
import {
  pageJump, getYmsLogisServiceData, setConfigCharacters, getWarehouseName, isJSON,
  getAllWarehouseData, getSupplierLogisticsData, EventBus, sumAmount, commonCopyContent,
  amountHandel, _handleMultilingualFields, setLinkPath, getQueryCarrierShippingName, getDataSetBatchList,
  getEnumList, getEnumName, getAllSuppliersData, commonLocalStorage, getTrackingNumberDisplayType
} from "@/utils/common";
import cancelOrderModal from "@/views/yms/components/orderList/cancelOrderModal.vue";
import commonLogModal from "@/components/common/commonLogModal.vue";
import addOrderTagsModal from "@/views/yms/components/orderList/addOrderTagsModal.vue";
import orderAmountModificationModal from "@/views/yms/components/orderList/orderAmountModificationModal.vue";
import viewCustomizedInfoModal from "@/components/common/viewCustomizedInfoModal.vue";
import cancelCustomizedProductOrdersModal from "@/components/common/cancelCustomizedProductOrdersModal.vue";
import {getAppScrollContainer, getAppScrollTop, isWindowScrollContainer} from "@/utils/appScroll";
import printComplianceLabelsModal from "@/components/common/printComplianceLabelsModal.vue";
import commonImportModal from "@/components/common/commonImportModal.vue";
import logisticsFeeReimbursementModal from "@/views/yms/components/orderList/logisticsFeeReimbursementModal.vue";
import orderProductModal from "@/views/yms/components/orderList/orderProductModal.vue";
import {endLoading, startLoading} from "@/utils/loading";

export default {
  name: 'orderList',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      total: 0,
      ymsPackageId: null,
      trackPlatform: null,
      trackingNumber: null,
      trackCarrierCode: null,
      modalTitle: '',
      ymsCoreStatus: '0', // 订单状态
      pageParams: {
        pageNum: 1,
        pageSize: 15,
        ymsWarehouseId: 'null', // 发货仓库
        labelType: null, // 发货方式
        abnormalStatus: null, // 异常状态
        createdStartTime: null, // 订单创建开始时间
        createdEndTime: null, // 订单创建结束时间
        shipedStartTime: null, // 订单发货开始时间
        shipedEndTime: null, // 订单发货结束时间
        cancelledStartTime: null, // 订单取消开始时间
        cancelledEndTime: null, // 订单取消结束时间
        updatedStartTime: null, //  状态更新开始时间
        updatedEndTime: null, // 状态更新结束时间
        trackingNumbers: '', // 运单号
        temuTagNumbers: '', // Temu标签号
        thirdPartyNos: '', // 物流商单号
        carrierThirdNos: '', // 物流三方单号
        packageCodes: '',
        ymsSkus: '', // 云卖sku
        ymsSpus: '', // 云卖spu
        distributorMerchantIds: '', // 分销商商户号
        orderShippingIds: '', // 分销商订单号
        subPackageCodes: '', // 供应商订单号
        supplierMerchantIds: '', // 供应商商户号
        carrierStatuList: 'null', // 下发状态
        source: 'null', // 来源
        isSelfOperated: 'null', // 是否存在平台自营商品
        packagePattern: null, // 出库模式
        orderType: 'null',
        ymsPackageTagIds: [],
        carrierId: null,
        shippingMethodId: null,
        upDown: 'down',
        orderBy: 'createdTime',
        performanceParty: 'YMS', // 履约方
      },
      dropDownInputList_1: [
        {title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, value: 1, placeholder: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000324')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004431')}`, parameterKey: 'packageCodes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004435'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004436'), parameterKey: 'orderShippingIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004369'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004437'), parameterKey: 'subPackageCodes'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'), value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004438'), parameterKey: 'trackingNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004405'), value: 5, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004439'), parameterKey: 'temuTagNumbers'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440'), value: 6, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004441'), parameterKey: 'thirdPartyNos'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004442'), value: 7, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004443'), parameterKey: 'carrierThirdNos'},
      ],
      dropDownInputList_2: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004325'), parameterKey: 'distributorMerchantIds'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004326'), parameterKey: 'supplierMerchantIds'}
      ],
      defaultSelectValue_1: 1,
      defaultSelectValue_2: 1,
      tableColumns: [
        {span: 5, key: 'productInfo', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383')},
        {span: 1, key: 'unitPrice', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001110')},
        {span: 1, key: 'quantity', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523')},
        {span: 3, key: 'orderAmount', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003599')},
        {span: 5, key: 'logisticsInfo', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001571')},
        {span: 4, key: 'shippingInfo', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004444')},
        {span: 2, key: 'supplierSubOrderInfo', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004445')},
        {span: 2, key: 'remarks', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')},
        {span: 1, key: 'operation', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319')},
      ],
      carrierStatusList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'null'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004446'), value: '1,4,7,10'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004447'), value: '2,5,8,11'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004448'), value: '13'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004449'), value: '3,6,9,12'}
      ],
      sourceList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'null'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004450'), value: 'YMS'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004451'), value: 'NOYMS'},
      ],
      tableData: [],
      selectTableData: [],
      packageData: [],
      ymsLogisServiceIdsData: [],
      exportType: null,
      warehouseList: [],
      limitTalg: true,
      customFieldExportList: [
        {
          title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004432')}`,
          titleKey: 'orderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2, 3], paramKey: 'packageCode', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`, disabled: true, disabledDrag: true},
            {type: [1, 2, 3], paramKey: 'status', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')}`},
            {type: [1, 2, 3], paramKey: 'distributorMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002877')},
            {type: [1, 2, 3], paramKey: 'orderShippingId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004435')},
            {type: [1, 2, 3], paramKey: 'supplierMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001098')},
            {type: [1, 2, 3], paramKey: 'carrierThirdNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004442')},
            {type: [1, 2, 3], paramKey: 'ymsSku', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004433')}`},
            {type: [1, 2, 3], paramKey: 'SKU', paramValue: 'SKU'},
            {type: [1, 2, 3], paramKey: 'productQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003656')},
            {type: [1, 2, 3], paramKey: 'amount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004452')},
            {type: [1, 2, 3], paramKey: 'totalAmount', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004453')},
            {type: [1, 2, 3], paramKey: 'handlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004454')},
            {type: [1, 2, 3], paramKey: 'prepayHandlePrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004455')},
            {type: [1, 2, 3], paramKey: 'totalShippingFeeIncome', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004456')},
            {type: [1, 2, 3], paramKey: 'actualLogisticsCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004457')},
            {type: [1, 2, 3], paramKey: 'returnedItemShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003637')},
            {type: [1, 2, 3], paramKey: 'remoteAreasShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003638')},
            {type: [1, 2, 3], paramKey: 'quadraticShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003639')},
            {type: [1, 2, 3], paramKey: 'cancelShippingCost', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003640')},
            {type: [1, 2, 3], paramKey: 'ymsLogisServiceName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000222')},
            {type: [1, 2, 3], paramKey: 'thirdPartyNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004440')},
            {type: [1, 2, 3], paramKey: 'trackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004458')},
            {type: [1, 2, 3], paramKey: 'virtualTrackingNumber', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004459')},
            {type: [1, 2, 3], paramKey: 'labelType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003867')},
            {type: [1, 2, 3], paramKey: 'packageCreatedTime', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003663')}`},
            {type: [1, 2, 3], paramKey: 'supplierPickupTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004460')},
            {type: [1, 2, 3], paramKey: 'corePickupTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004461')},
            {type: [1, 2, 3], paramKey: 'shipedTime', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003661')}`},
            {type: [1, 2, 3], paramKey: 'ymsLogisServiceEfficiency', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001613')}`},
            {type: [1, 2, 3], paramKey: 'cancelledTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004462')},
            {type: [1, 2, 3], paramKey: 'invalidReason', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004463')},
            {type: [1, 2, 3], paramKey: 'packageOrderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')},
            {type: [1, 2, 3], paramKey: 'customsClearanceFee', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003643')},
            {type: [1, 2, 3], paramKey: 'packageTagName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004465')},

            {type: [2, 3], paramKey: 'cnName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000380')},
            {type: [2, 3], paramKey: 'ymsSpu', paramValue: `${setConfigCharacters(false)}SPU`},
            {type: [2, 3], paramKey: 'goodsSpecification', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000721')},
            {type: [2, 3], paramKey: 'skuPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004466')},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004467'),
          titleKey: 'platformOrderInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2, 3], paramKey: 'platformName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001793')},
            {type: [1, 2, 3], paramKey: 'siteName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004468')},
            {type: [1, 2, 3], paramKey: 'platformAccountName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004469')},
            {type: [1, 2, 3], paramKey: 'platformOrderId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004470')},
            {type: [1, 2, 3], paramKey: 'totalPrice', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004471')},
            {type: [1, 2, 3], paramKey: 'totalPriceCurrency', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003611')},
            {type: [1, 2, 3], paramKey: 'platformOrderStatus', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004472')},
            {type: [1, 2, 3], paramKey: 'platformItemSku', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004473')},
            {type: [1, 2, 3], paramKey: 'createdYmsPackageTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004474')},
            {type: [1, 2, 3], paramKey: 'payTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004475')},
            {type: [1, 2, 3], paramKey: 'platformOrderType', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004464')},
          ]
        }
      ],
      dimensionTypeList: [
        {value: 1, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004476'), show: true},
        {value: 2, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004477'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004478'), show: true},
        {value: 3, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004477'), desc: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004479'), iconCenter: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004480'), show: true}
      ],
      dropDownTimeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003663'), value: 1, parameterKey: ['createdStartTime', 'createdEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003661'), value: 2, parameterKey: ['shipedStartTime', 'shipedEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004462'), value: 3, parameterKey: ['cancelledStartTime', 'cancelledEndTime']},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004481'), value: 4, parameterKey: ['updatedStartTime', 'updatedEndTime']}
      ],
      defaultSelectTimeValue: 1,
      sortData: [
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004037'), value: 'createdTime', checked: true, toogle: true},
        {label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004482'), value: 'updatedTime', checked: false, toogle: true}
      ],
      distributionLogisticsTalg: false,
      performancePartyList: [
        {value: 'YMS', name: 'YMS'},
        {value: 'ALIGJ', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002167')}
      ],
      ymsOrderLabelData: [],
      uploadZoneExcel: api.post_ymsPackageInfo_ImportActualWeight,
      importFormat: ['xls', 'xlsx'],
      timer: null,
      selectAllTable: false,
      fixedTalg: false,
      fixedTableTitleTalg: false,
      tableHeaderHeight: 58,
      tableHeaderOffsetTop: 0,
      orderTabTypeList: [
        {value: '0', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: '1', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800')},
        {value: '2', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001801')},
        {value: '3', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001994'), informationType: 2},
        {value: '4', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004193')},
        {value: '5', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001808'), informationType: 3},
        {value: '6', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002919'), informationType: 4},
        {value: '7', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001810'), informationType: 5},
        {value: '8', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004483'), informationType: 6},
        {value: '9', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327')},
        {value: '10', count: 0, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813')},
      ],
      enumData: [],
      currentSelectIndex: 0,
      labelTypeIndex: 0,
      logisticsScreeningList: [
        {value: 1, title: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004434')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}`},
        {value: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004484')},
      ],
      selectValue: 1,
      isSelfOperatedList: [
        {value: 'null', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000392')},
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000393')}
      ]
    };
  },
  computed: {
    filterKeyList() {
      let arr = [...this.dropDownInputList_1, ...this.dropDownInputList_2];
      let arr1 = arr.map((item) => {
        return item.parameterKey
      });
      let list = ['ymsSkus', 'ymsSpus', ...arr1];
      return list;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    showSidebarMenu() {
      return this.$store.state.showSidebarMenu;
    },
    // 处理物流渠道
    formatCarrierInfo() {
      return (item) => {
        let text = item.carrierName;
        if (item.carrierShippingMethodName) text += ' > ' + item.carrierShippingMethodName;
        if (item.logisticsCarrier) text += '（' + item.logisticsCarrier + '）';
        return text;
      }
    },
    // 预览图配置
    viewerConfig() {
      return {
        url: 'data-original',
        ...this.viewerOptions
      }
    },
    // 异常状态
    abnormalStatusList() {
      const ENUM_KEY = 'YmsPackageInfoAbnormalStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 0,
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item, index) => {
        item.selected = index === this.currentSelectIndex;
      });
      return list;
    },
    // 订单类型
    orderTypesList() {
      const ENUM_KEY = 'YmsPackageInfoOrderTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      list.unshift({
        value: 'null',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 发货方式
    labelTypeData() {
      const ENUM_KEY = 'YmsPackageInfoLabelTypeCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY);
      list.unshift({
        value: 'null',
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      list.forEach((item, index) => {
        item.selected = index === this.labelTypeIndex;
      });
      return list;
    },
    // 平台自营商品模式配置
    platformSelfOperatedProduct() {
      let saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.platformSelfOperatedProductModelSaas) === 1;
    },
    // 表头 fixed 时为包裹层占位，避免脱离文档流后列表内容上跳
    tableHeaderWrapStyle() {
      if (!this.fixedTableTitleTalg) {
        return {};
      }
      return {
        minHeight: `${this.tableHeaderHeight}px`
      };
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
  },
  mounted() {
    EventBus.$on('updateOrderList', (data) => {
      let obj = JSON.parse(data) || '';
      this.defaultConditionQuery(obj);
    });
    getAppScrollContainer().addEventListener('scroll', this.onScrollFixedTop);
    window.addEventListener('resize', this.handleWindowResize);
    this.$nextTick(() => {
      this.initFilterResizeObserver();
      this.syncTableHeaderStickyLayout();
    });
  },
  created() {
    this.showShippingData(true, true);
    // 获取消息中心跳转过来的参数
    let obj = localStorage.getItem('orderListQuery') ? JSON.parse(localStorage.getItem('orderListQuery')) : '';
    this.defaultConditionQuery(obj);
  },
  methods: {
    amountHandel,
    //复制方法 注：方法传参中不能有中文字，会导致翻译塞值报错
    commonCopyContentFun(value) {
      commonCopyContent(value, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'))
    },
    // 触发带着默认条件查询
    defaultConditionQuery(obj) {
      let v = this;
      if (obj) {
        v.$nextTick(() => {
          v.defaultSelectTimeValue = 4;
          let vals = {
            date: [obj.updatedStartTime, obj.updatedEndTime],
            value: v.defaultSelectTimeValue
          }
          v.orderTabTypeList.map((item, index) => {
            if (item.informationType === obj.informationType) {
              v.ymsCoreStatus = item.value;
            }
          });
          v.selectTime(vals);
          v.initFun(false);
          setTimeout(() => {
            localStorage.removeItem('orderListQuery');
            v.$store.commit('updateSystemMenu', false);
          }, 2000);
        });
      } else {
        v.initFun(true);
      }
    },
    // 初始化接口数据
    initFun(val) {
      let v = this;
      if (val) {
        v.setDefaultTimerParams('three_months', 1);
      }
      v.warehouseList = [];
      (async () => {
        let enumKeyList = [
          'YmsPackageInfoAbnormalStatusCoreEnum',
          'YmsPackageInfoOrderTypeCoreEnum',
          'YmsPackageInfoSubPackageGoodsStatusCoreEnum',
          'YmsPackageInfoLabelTypeCoreEnum',
          'YmsCarrierErrorMsgCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getAllWarehouseData({servicePlatforms: ['core', 'supplier']}).then((data) => {
          v.warehouseList = data.filter((item) => {
            return (item.isDeliveryWarehouse === 1 && item.servicePlatform === 'supplier') || item.servicePlatform === 'core';
          });
          v.warehouseList.unshift({
            ymsWarehouseId: 'null',
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
          });
        });
        await v.getYmsOrderLabelData();
        v.search();
        await v.getYmsOrderGoodsNum();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      this.labelTypeIndex = 0;
      this.currentSelectIndex = 0;
      this.selectTableData = [];
      this.$refs['pageParams'].resetFields();
      this.shippingMethodModel = [];
      this.pageParams.carrierId = null;
      this.pageParams.shippingMethodId = null;
      this.labelTypeStatus(0, null);
      this.abnormalStatusBtn(0, null);
      this.changeInput(1, '_1');
      this.changeInput(1, '_2');
      this.changeTimeInput(1);
      this.setDefaultTimerParams('three_months', 1);
      this.changeInputValue(1);
      this.search();
    },
    // 参数处理
    handleParameter() {
      let v = this;
      v.limitTalg = true;
      let params = Object.assign({}, v.pageParams);
      if (v.pageParams.carrierStatuList !== 'null') {
        params.carrierStatuList = v.pageParams.carrierStatuList.split(',');
      } else {
        params.carrierStatuList = [];
      }
      let keyList = ['ymsWarehouseId', 'orderType', 'labelType', 'isSelfOperated'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], [',', '，', '\n']);
        }
      }
      params.ymsCoreStatus = Number(v.ymsCoreStatus);
      return params;
    },
    // 列表查询的方法
    getList() {
      const v = this;
      v.selectAllTable = false;
      v.tableData = [];
      v.selectTableData = [];
      v.total = 0;
      if (!v.getPermission('ymsPackageInfo_query')) {
        v.gotoError();
        return;
      }
      const query = v.handleParameter();
      let limitFlag = true;
      for (let key in query) {
        if (v.filterKeyList.includes(key) && query[key].length > 1000) {
          limitFlag = false;
          break;
        }
      }
      if (!limitFlag) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004485'));
        return;
      }
      v.timer = setInterval(() => {
        startLoading(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003332'))
      }, 20);
      v.tableLoading = true;
      v.axios.post(api.post_ymsPackageInfo_query, query).then(response => {
        if (response.data.code !== 0) {
          endLoading();
          clearInterval(v.timer);
          return;
        }
        v.tableLoading = false;
        const data = response.data.datas;
        const list = data.list || [];
        v.total = data.total || 0;
        if (list.length === 0) {
          endLoading();
          clearInterval(v.timer);
          v.$nextTick(() => {
            v.syncTableHeaderStickyLayout();
          });
          return;
        }
        const shippingMethodIds = Array.from(new Set(list.map(item => item.shippingMethodId).filter(Boolean)));
        const ymsLogisServiceIds = Array.from(new Set(list.map(item => item.ymsLogisServiceId).filter(Boolean)));
        let ymsProductGoodsIds = [];
        list.map((item) => {
          let ymsPackageGoods = item.ymsPackageGoods || [];
          ymsPackageGoods.map((ele) => {
            if (ele.ymsProductGoodsId) {
              ymsProductGoodsIds.push(ele.ymsProductGoodsId)
            }
          });
        });
        ymsProductGoodsIds = v.uniqueFunc(ymsProductGoodsIds);
        // 并发请求物流信息和邮寄方式
        Promise.all([
          v.getProductInfoByIds(ymsProductGoodsIds, [], false, true),
          getYmsLogisServiceData(ymsLogisServiceIds),
          getSupplierLogisticsData(shippingMethodIds),
          getQueryCarrierShippingName(shippingMethodIds)
        ]).then(([ymsProductGoodData, ymsLogistics, supplierLogistics, distributorLogistics]) => {
          ymsLogistics = ymsLogistics || [];
          v.ymsLogisServiceIdsData = ymsLogistics;
          supplierLogistics = supplierLogistics || [];
          distributorLogistics = distributorLogistics || [];
          // 绑定物流信息
          list.forEach(item => {
            item.viewMoreTalg = false;
            item.viewRemarkMoreTalg = false;
            item.logisticsCarrier = null;
            item.tableChecked = false;
            // 分销商物流
            if (distributorLogistics.length > 0 && item.shippingMethodId) {
              const carrierInfo = distributorLogistics.find(e => e.shippingMethodId === item.shippingMethodId);
              if (carrierInfo) {
                item.carrierShippingMethodName = carrierInfo.carrierShippingMethodName;
                item.carrierName = carrierInfo.carrierName;
                item.logisticsCarrier = carrierInfo.logisticsCarrier;
                item.performanceType = carrierInfo.performanceType;
              }
            }
            // 供应商物流
            if (supplierLogistics.length > 0 && item.shippingMethodId) {
              const carrierInfo = supplierLogistics.find(e => e.shippingMethodId === item.shippingMethodId);
              if (carrierInfo) {
                item.carrierShippingMethodName = carrierInfo.carrierShippingMethodName;
                item.carrierName = carrierInfo.carrierName;
                item.logisticsCarrier = carrierInfo.logisticsCarrier;
                item.performanceType = carrierInfo.performanceType;
              }
            }
            // 云卖物流
            if (ymsLogistics.length > 0 && item.ymsLogisServiceId) {
              const ymsService = ymsLogistics.find(e => e.ymsLogisServiceId === item.ymsLogisServiceId);
              if (ymsService) {
                item.carrierName = ymsService.name;
              }
            }
            // 货品信息
            let ymsPackageGoods = item.ymsPackageGoods || [];
            if (ymsProductGoodData && ymsProductGoodData.length > 0) {
              ymsPackageGoods.map((k) => {
                let primaryImage = null;
                let isSelfOperated = 0;
                let valueList = [];
                ymsProductGoodData.map((ele) => {
                  if (k.ymsProductId === ele.ymsProductId) {
                    let ymsProductGoodsList = ele.ymsProductGoodsList || [];
                    ymsProductGoodsList.map((j) => {
                      if (k.ymsProductGoodsId === j.ymsProductGoodsId) {
                        isSelfOperated = ele.isSelfOperated;
                        primaryImage = j.primaryImage || ele.primaryImage;
                        let productGoodsSpecificationList = j.productGoodsSpecificationList || [];
                        valueList = productGoodsSpecificationList.map((p) => {
                          return p.value;
                        });
                      }
                    });
                  }
                });
                k.isSelfOperated = isSelfOperated;
                k.specifications = valueList.join(' • ');
                k.primaryImage = primaryImage;
              });
            }
          });
          v.tableData = v.handleTableData(list);
          v.$nextTick(() => {
            v.syncTableHeaderStickyLayout();
          });
          endLoading();
          clearInterval(v.timer);
        }).finally(() => {
          endLoading();
          clearInterval(v.timer);
        });
      }).catch(error => {
        console.error(error);
        endLoading();
        clearInterval(v.timer);
      });
    },
    // 处理列表数据
    handleTableData(data) {
      let v = this;
      return data.map((item) => {
        let {
          status, payStatus, orderType, isHand, ymsLogisServiceId, trackingNumber, warehouseId, ymsWarehouseId,
          ymsPackageTagIds, abnormalStatus, estimateFreight, totalPriceCurrency, isSupplierSupportDirectDelivery,
          carrierMerchantType, subPackageGoodsStatus, remark, carrierStatus, labelType, ymsCoreStatus
        } = item;
        item.carrierName = _handleMultilingualFields(item.carrierName);
        item.carrierShippingMethodName = _handleMultilingualFields(item.carrierShippingMethodName);
        // 处理订单状态
        const processOrderStatusFun = () => {
          let orderStatusText = '';
          if (payStatus === 1) {
            if (status === 8) {
              orderStatusText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001813');
            } else {
              orderStatusText = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001800');
            }
          } else {
            v.orderTabTypeList.map((item) => {
              if (Number(item.value) === ymsCoreStatus) {
                if (['TEMU_P', 'TEMU_S'].includes(orderType)) {
                  let name = '';
                  if (v.ymsLogisServiceIdsData.length > 0) {
                    v.ymsLogisServiceIdsData.map((item) => {
                      if (item.ymsLogisServiceId === ymsLogisServiceId) {
                        name = item.name;
                      }
                    });
                  }
                  /**
                   * 1.没有云卖物流
                   * 2.订单状态是待拣货
                   * 3.手工-货品单
                   * 4. 没有运单号
                   * 满足以上的条件不展示---（待执行发货）
                   */
                  if (!name && status === 3 && !(isHand === 2 && orderType === 'TEMU_P')
                    && (!trackingNumber || trackingNumber === '-')) {
                    orderStatusText = item.title + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004486');
                  } else {
                    orderStatusText = item.title;
                  }
                } else {
                  orderStatusText = item.title;
                }
              }
            });
          }
          return orderStatusText;
        }
        // 处理Temu标签
        const processTemuLabelFun = () => {
          let objLabel = {
            TEMU_S: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004409'),
            TEMU_P: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004410'),
          };
          return objLabel[orderType] || '';
        }
        // 处理订单标签
        const processOrderLabelFun = () => {
          let processOrderLabelName = '';
          ymsPackageTagIds = Array.isArray(ymsPackageTagIds) ? ymsPackageTagIds : [];
          v.ymsOrderLabelData.map((ele) => {
            if (ele.ymsPackageTagId === ymsPackageTagIds[0]) {
              processOrderLabelName = ele.tagName;
            }
          });
          return processOrderLabelName;
        }
        // 处理下发状态
        const processIssueStatusFun = (type) => {
          let text = '';
          // 下发状态  1.待申请 2.申请中 3.申请失败 4.待获取运单 5.获取运单号中 6.获取运单号失败
          // 7.待交运 8.交运中 9.交运失败 10.待获取面单 11.获取面单中 12.获取面单失败 13.面单获取成功
          /**
           * 待下发 [1,4,7,10,14]
           * 下发中 [2,5,8,11,15]
           * 下发成功 [13]
           * 下发失败 [3,6,9,12,16]
           */
          let toBeIssued = [1, 4, 7, 10, 14];
          let Issuing = [2, 5, 8, 11, 15];
          let ssuedSuccessfully = [13];
          let distributionFailed = [3, 6, 9, 12, 16];
          if (toBeIssued.includes(carrierStatus)) {
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004446');
          } else if (Issuing.includes(carrierStatus)) {
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004447');
          } else if (ssuedSuccessfully.includes(carrierStatus)) {
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004448');
          } else if (distributionFailed.includes(carrierStatus)) {
            text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004449');
          }
          return type === 'status' ? text : distributionFailed.includes(carrierStatus);
        }
        // 处理异常状态
        const processAbnormalStatusFun = () => {
          return getEnumName(v.enumData, 'YmsPackageInfoAbnormalStatusCoreEnum', abnormalStatus, 'number');
        }
        // 处理预付物流费
        const prepaidLogisticsFees = () => {
          let prepaidLogisticsFees = '-';
          if (payStatus === 1) {
            prepaidLogisticsFees = v.formatCurrency(estimateFreight) + ' ' + totalPriceCurrency;
          } else {
            prepaidLogisticsFees = v.orderAmountHandel(item, 4) || v.orderAmountHandel(item, 9);
          }
          return prepaidLogisticsFees;
        }
        // 处理发货方式
        const shippingMethodNameFun = () => {
          let shippingMethodName = '';
          v.labelTypeData.map((item) => {
            if (item.value === labelType) {
              if (item.value === null) {
                shippingMethodName = '-';
              } else {
                shippingMethodName = item.title;
              }
            }
          });
          return shippingMethodName;
        }
        // 处理发货仓库
        const deliveryWarehouseNameFun = (type) => {
          let deliveryWarehouseName = '';
          let originalWarehouseName = '';
          if (isSupplierSupportDirectDelivery === 1) {
            if (warehouseId === ymsWarehouseId) {
              deliveryWarehouseName = getWarehouseName(v.warehouseList, warehouseId);
            } else {
              deliveryWarehouseName = getWarehouseName(v.warehouseList, warehouseId);
              originalWarehouseName = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004487') + getWarehouseName(v.warehouseList, ymsWarehouseId) + ')'
            }
          } else {
            deliveryWarehouseName = getWarehouseName(v.warehouseList, ymsWarehouseId);
          }
          if (type === 'deliveryWarehouse') {
            return deliveryWarehouseName;
          } else {
            return originalWarehouseName;
          }
        }
        // 处理客选物流
        const customerSelectedLogisticsNameFun = () => {
          let customerSelectedLogisticsName = carrierMerchantType === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004484') : carrierMerchantType === 2 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004488') : '';
          if (v.ymsLogisServiceIdsData.length > 0) {
            v.ymsLogisServiceIdsData.map((item) => {
              if (item.ymsLogisServiceId === ymsLogisServiceId) {
                if (carrierMerchantType === 3) {
                  customerSelectedLogisticsName = item.name;
                }
              }
            });
          }
          return customerSelectedLogisticsName;
        }
        // 处理供应商子单状态
        const subPackageGoodsStatusNameFun = () => {
          let text = getEnumName(v.enumData, 'YmsPackageInfoSubPackageGoodsStatusCoreEnum', subPackageGoodsStatus, 'number');
          return text !== '-' ? text : null;
        }
        // 处理备注内容
        const processRemarkContentFun = () => {
          let newList = [];
          if (remark && isJSON(remark)) {
            let remarkList = JSON.parse(remark);
            remarkList.map((item, index) => {
              let currentIndex = index + 1;
              let content = currentIndex + '.' + item
              newList.push({
                content: content,
                viewRemarkMoreTalg: index <= 2 ? true : item.viewRemarkMoreTalg
              });
            });
          }
          return newList;
        }
        return {
          ...item,
          orderStatusText: processOrderStatusFun(),
          temuLabelName: processTemuLabelFun(),
          orderLabelName: processOrderLabelFun(),
          abnormalStatusText: processAbnormalStatusFun(),
          prepaidLogisticsFees: prepaidLogisticsFees(),
          shippingMethodName: shippingMethodNameFun(),
          deliveryWarehouseName: deliveryWarehouseNameFun('deliveryWarehouse'),
          originalWarehouseName: deliveryWarehouseNameFun('originalWarehouse'),
          customerSelectedLogisticsName: customerSelectedLogisticsNameFun(),
          subPackageGoodsStatusName: subPackageGoodsStatusNameFun(),
          remarkList: processRemarkContentFun(),
          processIssueStatusText: processIssueStatusFun('status'),
          processIssueStatusTalg: processIssueStatusFun('error'),
        };
      });
    },
    // 选取面单类型
    labelTypeStatus(index, value) {
      this.pageParams.labelType = value;
      this.labelTypeIndex = index;
    },
    // 选取异常状态
    abnormalStatusBtn(index, value) {
      this.pageParams.abnormalStatus = value;
      this.currentSelectIndex = index;
    },
    // 选取承运商成功后，要更新轨迹信息和列表数据
    selectionData(code) {
      let v = this;
      let url = '';
      let methods = '';
      let text = '';
      let query = {};
      // 更新承运商
      if (v.trackingNumber && v.trackCarrierCode) {
        query = {
          trackCarrierCode: code,
          ymsPackageIds: [v.ymsPackageId]
        };
        url = api.put_ymsPackageInfo_updateLogisticsTracking;
        methods = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001160');
      }
      // 添加承运商
      else {
        query = {
          trackPlatform: v.trackPlatform,
          updateLogisticsTrackingBos: [
            {
              trackCarrierCode: code,
              ymsPackageId: v.ymsPackageId
            }
          ]
        };
        url = api.post_ymsPackageInfo_addLogisticsTracking;
        methods = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000776');
      }
      v.axios[methods](url, query, {loading: true}).then((res) => {
        if (res.data.code === 0) {
          v.$refs.carrierInfo.carrierTableModal = false;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.updateTableData();
        }
      });
    },
    // 全选当前列表数据
    allTableChange(value) {
      this.tableData.map((item) => {
        item.tableChecked = value;
      });
      this.handleSelectTableData();
      this.$forceUpdate();
    },
    // 单个选中列表数据
    tableChange() {
      this.handleSelectTableData();
      this.$forceUpdate();
    },
    // 处理勾选中的数据
    handleSelectTableData() {
      this.selectTableData = [];
      let data = this.tableData.filter((item) => {
        return item.tableChecked;
      });
      this.selectTableData = data;
      this.selectAllTable = data.length === this.tableData.length;
      if (data) {
        // 获取需要修改物流方式的数据
        this.packageData = data.reduce((result, i) => {
          const isYmsLogistics = i.ymsLogisServiceId || ['YMS', 'yms'].includes(i.source); // 是云卖物流或订单来源是自有渠道的才可以修改物流
          if (isYmsLogistics) {
            result.push({
              ...i,
              pickingNo: i.packageCode,
              logisticsDealerName: i.carrierName,
              logisticsMailName: i.carrierShippingMethodName,
              consigneeCountry: i.buyerCountryCode,
              pickingId: i.ymsPackageId
            });
          }
          return result;
        }, []);
      }
    },
    // 下发物流
    distributionLogisticsBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        const allowedPayStatus = [2]; // 已付款的状态
        const statusList = [1, 4, 7, 10, 3, 6, 9, 12, 16]; // 待下发的状态  [1, 4, 7, 10] 下发失败的状态 [3, 6, 9, 12, 16]
        // 校验选中的订单状态
        let allowedCarrierStatusesTalg = v.selectTableData.every((order) => {
          return statusList.includes(order.carrierStatus) && allowedPayStatus.includes(order.payStatus);
        })
        if (allowedCarrierStatusesTalg) {
          v.distributionLogisticsTalg = true;
          let list = v.selectTableData.map((item) => {
            return item.ymsPackageId
          });
          v.axios.put(api.put_ymsPackageInfo_uploadLogistics, list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
              v.selectTableData = [];
              v.updateTableData();
              v.distributionLogisticsTalg = false;
            }
          });
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004489'));
          return false;
        }
      } else {
        v.distributionLogisticsTalg = false;
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004490'));
        return false;
      }
    },
    // 修改物流方式
    modifyMailFn() {
      let v = this;
      if (v.selectTableData.length === 0) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004491'));
        return false;
      }
      const firstYmsWarehouseId = v.selectTableData[0]?.ymsWarehouseId;
      const allSameYmsWarehouseId = v.selectTableData.every(item => item.ymsWarehouseId === firstYmsWarehouseId);
      if (!allSameYmsWarehouseId) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004492'));
        return false;
      }
      v.$refs['modifyMailingMethod'].modifyMailingMethodModal = true;
      v.$refs['modifyMailingMethod'].ymsWarehouseId = firstYmsWarehouseId;
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value, type) {
      this['defaultSelectValue' + type] = value;
      this.$refs['dropDownFilter' + type].inputValue = '';
      this['dropDownInputList' + type].map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn(obj) {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsPackageIds = v.selectTableData.map((item) => {
          return item.ymsPackageId
        });
      } else {
        query.ymsPackageIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((value) => {
        if (value) {
          query.exportType = obj.dimensionType;
          v.axios.post(api.post_ymsPackageInfo_exportYmsPackageInfo, query,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30)
            }
          });
        }
      });
    },
    // 获取选中的时间
    selectTime(data) {
      let v = this;
      let time = data.date;
      let timeList = v.defaultTimePeriod(time);
      let current = data.value;
      v.dropDownTimeList.map((item) => {
        if (item.value === current) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          v.$nextTick(() => {
            v.$refs['dropDownDateTime'].timeList = v.defaultTimePeriod(time, false);
          });
          v.pageParams[startTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams[endTimeKey] = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      });
    },
    // 改变默认时间筛选下拉选项的值
    changeTimeInput(value) {
      this.defaultSelectTimeValue = value;
      this.$refs['dropDownDateTime'].timeList = [];
      this.dropDownTimeList.map((item) => {
        let startTimeKey = item.parameterKey[0];
        let endTimeKey = item.parameterKey[1];
        this.pageParams[startTimeKey] = null;
        this.pageParams[endTimeKey] = null;
      });
    },
    // 重置选中的时间
    resetTime(value) {
      this.dropDownTimeList.map((item) => {
        if (item.value === value) {
          let startTimeKey = item.parameterKey[0];
          let endTimeKey = item.parameterKey[1];
          this.pageParams[startTimeKey] = null;
          this.pageParams[endTimeKey] = null;
        }
      });
    },
    // 选择物流方式
    changeShippingMethod(value, data) {
      let v = this;

      function setTimeoutFn(val) {
        v.$nextTick(() => {
          setTimeout(() => {
            const cascader = v.$refs['cascaderDom'];
            if (cascader) {
              // 选中值之后，强制显示下拉菜单
              cascader.visible = true;
              // 滚动到选中值
              const value = v.shippingMethodModel;
              const firstValue = value[0];
              const menu = cascader.$el.querySelector('.ivu-cascader-menu');
              if (!menu) return;
              const items = menu.querySelectorAll('.ivu-cascader-menu-item');
              let target = null;
              items.forEach(el => {
                if (el.__vue__ && el.__vue__.data) {
                  if (el.__vue__.data.value == firstValue) {
                    target = el;
                  }
                }
              });
              if (target) {
                target.scrollIntoView({
                  block: 'center',
                  behavior: 'smooth'
                });
              }
              if (val) {
                v.shippingMethodModel = [];
              }
            }
          }, 5);
        });
      }

      switch (v.selectValue) {
        // YMS物流
        case 1:
          if (value.length === 0) {
            v.pageParams.carrierId = null;
            v.pageParams.shippingMethodId = null;
          } else if (value.length === 1) {
            v.pageParams.carrierId = value[0];
            v.pageParams.shippingMethodId = null;
            setTimeoutFn();
          } else if (value.length === 2) {
            v.pageParams.carrierId = value[0];
            v.pageParams.shippingMethodId = value[1][0];
          }
          break;
        // 供应商自有物流
        case 2:
          if (value.length === 1) {
            v.pageParams.carrierId = null;
            v.pageParams.shippingMethodId = null;
            setTimeoutFn(true);
            return;
          }
          // 选到物流商
          if (value.length === 2) {
            v.pageParams.carrierId = value[1];
            v.pageParams.shippingMethodId = null;
          }
          // 选到物流渠道
          else if (value.length === 3) {
            v.pageParams.carrierId = value[1];
            v.pageParams.shippingMethodId = value[2];
          }
          break;
      }
    },
    // 点击排序的按钮
    clickSortButton(data) {
      if (data.value === this.pageParams.orderBy) {
        data.toogle = !data.toogle;
      }
      if (data.toogle) {
        this.pageParams.upDown = 'down';
      } else {
        this.pageParams.upDown = 'up';
      }
      this.sortData.forEach(function (n) {
        n.checked = data.value === n.value;
      });
      this.pageParams.orderBy = data.value;
      this.pageParamsStatus = true;
    },
    // 通知分销商
    notifyDistributorsBtn(ymsPackageId) {
      let v = this;
      v.axios.put(api.put_ymsPackageInfo_notifyDistributor + ymsPackageId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
        if (res.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
        }
      });
    },
    // 获取yms订单标签
    getYmsOrderLabelData() {
      this.ymsOrderLabelData = [];
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsPackageTag_queryAllTags).then(response => {
          if (response.data.code === 0) {
            this.ymsOrderLabelData = response.data.datas || [];
            resolve(this.ymsOrderLabelData);
          }
        });
      });
    },
    // 添加标签
    addTagsBtn(type, ymsPackageId) {
      let ymsPackageIdList = [];
      if (type === 'all') {
        if (this.selectTableData.length > 0) {
          ymsPackageIdList = this.selectTableData.map((item) => {
            return item.ymsPackageId
          });
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004493'));
          return false;
        }
      } else {
        ymsPackageIdList = [ymsPackageId];
      }
      if (ymsPackageIdList.length > 0) {
        this.$refs['addOrderTags'].initAddOrderTagsData(ymsPackageIdList, 'tags');
      }
    },
    // 删除标签
    deleteATapBtn(ymsPackageId, ymsPackageTagIds) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004494'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004495'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004301'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          let query = {
            remark: null,
            ymsPackageIds: [ymsPackageId],
            ymsPackageTagId: ymsPackageTagIds[0],
          }
          v.axios.post(api.post_ymsPackageInfo_deleteTag, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
              v.updateTableData();
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 跳转到订单详情
    toOrderDetails(item) {
      const {href} = this.$router.resolve({
        path: '/orderListDetails',
        query: {
          ymsPackageId: item.ymsPackageId
        }
      });
      window.open(href, '_blank');
    },
    // 处理时间时区
    formatTime(time) {
      return time ? this.$uDate.dealTime(time, 'fulltime') : '-'
    },
    // 订单费用处理
    orderAmountHandel(params, type, isCheck = false, isValue = false) {
      let ymsPackageCosts = params.ymsPackageCosts || [];
      // 校验是否有对应类型金额值
      if (isCheck) {
        if (isValue) {
          return sumAmount(ymsPackageCosts)[type] && sumAmount(ymsPackageCosts)[type] > 0 ? true : false;
        } else {
          return sumAmount(ymsPackageCosts, type) !== '-';
        }
      } else {
        return sumAmount(ymsPackageCosts, type, {withCurrency: true, decimals: 2, thousand: true});
      }
    },
    // 添加、更新承运商
    carrierBtn(item) {
      this.trackPlatform = item.trackPlatform;
      this.ymsPackageId = item.ymsPackageId;
      this.trackingNumber = item.trackingNumber;
      this.trackCarrierCode = item.trackCarrierCode;
      this.modalTitle = item.trackCarrierCode ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004496') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004497');
      this.$refs['carrierInfo']['initCarrierData']();
    },
    // 查看子单
    viewSubOrdersBtn(ymsPackageId) {
      const {href} = this.$router.resolve({
        path: '/orderListDetails',
        query: {
          ymsPackageId: ymsPackageId
        }
      });
      window.open(href, '_blank');
    },
    // 查看商品详情
    toGoodsDetails(obj) {
      const {href} = this.$router.resolve({
        path: obj.isSelfOperated === 1 ? '/selfOperatedProductsDetails' : '/productDetails',
        query: {
          type: 'look',
          productId: obj.ymsProductId,
          supplierMerchantId: obj.supplierMerchantId,
          platformId: obj.platformId || null
        }
      });
      window.open(href, '_blank');
    },
    // 查看更多备注内容
    showMoreRemark(idx, value) {
      this.$set(this.tableData[idx], 'viewRemarkMoreTalg', !value)
    },
    // 允许取消
    allowCancellationBtn(item) {
      // 允许取消定制商品订单
      if (item.isNeedCustomization === 1) {
        this.$refs['cancelCustomizedProductOrders'].initCancelCustomizedProductOrdersData('ymsAllowCancel', item);
      }
      // 允许取消非定制商品
      else {
        this.$refs['allowCancellationOfOrders'].initAllowCancellationOfOrdersData(item);
      }
    },
    // 取消订单
    cancelOrderBtn(item) {
      // 取消定制商品订单
      if (item.isNeedCustomization === 1) {
        this.$refs['cancelCustomizedProductOrders'].initCancelCustomizedProductOrdersData('ymsCancelOrder', item)
      }
      // 取消非定制商品
      else {
        this.$refs['cancelOrder'].initCancelOrderData(item.ymsPackageId, item)
      }
    },
    // scroll 事件 rAF 节流，避免同帧内重复触发吸顶判断
    onScrollFixedTop() {
      if (this._scrollFixedRaf) {
        return;
      }
      this._scrollFixedRaf = requestAnimationFrame(() => {
        this._scrollFixedRaf = null;
        this.scrollFixedTopFun();
      });
    },
    // 窗口尺寸变化后重新校准表头吸顶参数
    handleWindowResize() {
      this.syncTableHeaderStickyLayout();
    },
    // 监听筛选区高度变化，适配未来新增筛选项或展开收起
    initFilterResizeObserver() {
      if (!window.ResizeObserver || !this.$refs.filterBox) {
        return;
      }
      this._filterResizeObserver = new ResizeObserver(() => {
        this.syncTableHeaderStickyLayout();
      });
      this._filterResizeObserver.observe(this.$refs.filterBox);
    },
    // 统一同步表头 offset、占位高度与吸顶状态
    syncTableHeaderStickyLayout() {
      this.updateTableHeaderOffsetTop();
      this.updateTableHeaderHeight();
      this.scrollFixedTopFun();
    },
    // 记录表头容器在滚动坐标系中的位置，供 scrollTop 吸顶判断使用
    updateTableHeaderOffsetTop() {
      const tableHeaderWrap = this.$refs.tableHeaderWrap;
      const container = getAppScrollContainer();
      if (!tableHeaderWrap || !container) {
        return;
      }
      const scrollTop = getAppScrollTop(container);
      const containerTop = isWindowScrollContainer(container) ? 0 : container.getBoundingClientRect().top;
      this.tableHeaderOffsetTop = scrollTop + tableHeaderWrap.getBoundingClientRect().top - containerTop;
    },
    // 根据 scrollTop 与预存 offsetTop 判断是否吸顶，避免滚到底部时 wrapTop 临界振荡
    scrollFixedTopFun() {
      const TOP_TABDISTANCE = 120;
      const TABLE_HEADER_FIXED_TOP = 102;
      const TABLE_HEADER_HYSTERESIS = 16;
      const scrollTop = getAppScrollTop(getAppScrollContainer());
      this.fixedTalg = scrollTop > TOP_TABDISTANCE;
      if (!this.tableHeaderOffsetTop) {
        return;
      }
      const stickyStart = this.tableHeaderOffsetTop - TABLE_HEADER_FIXED_TOP;
      if (!this.fixedTableTitleTalg) {
        this.fixedTableTitleTalg = scrollTop >= stickyStart;
      } else {
        this.fixedTableTitleTalg = scrollTop >= stickyStart - TABLE_HEADER_HYSTERESIS;
      }
    },
    // 测量表头实际占位高度，供 fixed 时包裹层 minHeight 使用
    updateTableHeaderHeight() {
      if (this.fixedTableTitleTalg) {
        return;
      }
      const tableHeaderWrap = this.$refs.tableHeaderWrap;
      if (!tableHeaderWrap) {
        return;
      }
      const height = tableHeaderWrap.offsetHeight;
      if (height > 0) {
        this.tableHeaderHeight = height;
      }
    },
    // 动态设置tab的样式
    tabStyles() {
      let style = {
        width: this.showSidebarMenu ? '100%' : 'calc(100% - 270px)',
        left: this.showSidebarMenu ? '0' : '255px'
      }
      return this.fixedTalg ? style : ''
    },
    // 动态设置table的样式
    tableTitleStyles() {
      let style = {
        width: this.showSidebarMenu ? '100%' : 'calc(100% - 270px)',
        left: this.showSidebarMenu ? '0' : '255px'
      }
      return this.fixedTableTitleTalg ? style : ''
    },
    // 处理是否展示允许取消按钮
    shoWallowCancellation(item) {
      return ((item.status === 6 && item.isNeedCustomization === 0) ||
        (item.payStatus !== 1 && ![7, 8].includes(item.status) && item.isNeedCustomization === 1)) && item.allowInvalid === 0;
    },
    // 处理是否展示取消订单按钮
    showCancelOrder(item) {
      const {status, isNeedCustomization, payStatus, performanceParty} = item;
      if (status === 8) return false;
      const canCancel = isNeedCustomization === 0 ? [1, 2].includes(status) || payStatus === 1 : ![6, 7, 8].includes(status);
      return canCancel && this.getPermission('ymsPackageInfo_cancelPackageInfo') && performanceParty !== 'ALIGJ';
    },
    // 处理Tab订单数
    renderLabel(item) {
      let valueList = ['9', '10'];
      let talg = !valueList.includes(item.value) && item.count > 0;
      return (h) => h("div", [
        h("span", item.title),
        talg ? h("Badge", {
          props: {
            count: item.count,
            overflowCount: 999
          }
        }) : ''
      ]);
    },
    // 处理备注数据
    getRemarkList(item) {
      return item.viewRemarkMoreTalg ? (item.remarkList || []) : (item.remarkList || []).slice(0, 3);
    },
    // 获取yms订单对应状态下商品数量
    getYmsOrderGoodsNum() {
      return new Promise((resolve) => {
        this.axios.get(api.get_ymsPackageInfo_queryForCount).then((response) => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              this.orderTabTypeList.map((item) => {
                let value = Number(item.value);
                item.count = data[value] || 0;
              })
            }
            resolve(data);
          }
        })
      });
    },
    getTrackingNumberDisplayType,
    // 手动获取运单号
    manualGetTrackingNumber(item) {
      this.axios.get(api.get_ymsPackageInfo_getTrackingNumber + item.ymsPackageId,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004498')}).then((response) => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          this.updateTableData();
        }
      });
    },
    // 更新列表数据
    updateTableData() {
      this.pageParamsStatus = true;
      this.getYmsOrderGoodsNum();
    },
    // 切换Tab
    changeTab() {
      this.reset();
    },
    // 下载面单
    downloadTheWaybill(item) {
      if (item.labelPath) {
        let link = setLinkPath(item.labelPath);
        window.open(link, '_blank');
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
        return false;
      }
    },
    // 选择物流方式
    changeInputValue(value) {
      this.selectValue = value;
      this.shippingMethodData = [];
      this.shippingMethodModel = [];
      this.pageParams.carrierId = null;
      this.pageParams.shippingMethodId = null;
      value === 1 ? this.showShippingData(true, true) : this.showSupplierInfoData(true);
    },
    // 获取所有供应商信息
    async showSupplierInfoData(value) {
      if (!value) return;
      let arr = await getAllSuppliersData({checkOwnCarrier: 1});
      this.shippingMethodData = arr.map(item => ({
        value: item.ymsMerchantId,
        label: item.supplierMerchantName,
        children: [],
        loading: false
      }));
    },
    // 获取供应商自有物流
    supplierLoadData(item, callback) {
      item.loading = true;
      let query = {
        supplierMerchantIds: [item.value]
      };
      this.axios.post(api.post_ymsCarrier_querySupplierCarrier, query).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let carrierList = data.map((k) => {
            let methods = k.carrierShippingMethods || [];
            return {
              value: k.carrierId,
              label: k.carrierName,
              children: methods.map((ele) => {
                return {
                  value: ele.shippingMethodId,
                  label: ele.carrierShippingMethodName
                };
              })
            };
          });
          item.children = carrierList;
          item.loading = false;
          callback();
          if (carrierList.length === 0) {
            this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000142'));
          }
        } else {
          item.children = [];
          item.loading = false;
        }
      }).catch(() => {
        item.children = [];
        item.loading = false;
      });
    },
    // 获取下发物流失败具体内容
    getFailureContent(carrierErrorMsg) {
      let list = getEnumList(this.enumData, 'YmsCarrierErrorMsgCoreEnum');
      let val = carrierErrorMsg;
      list.map((item) => {
        if (item.value === carrierErrorMsg) {
          val = item.name;
        }
      });
      return val;
    },
  },
  watch: {
    // 监听更多筛选条件
    moreFilter() {
      this.$nextTick(() => {
        this.syncTableHeaderStickyLayout();
      });
    },
    // 监听列表数据更新
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('updateOrderList');
  },
  destroyed() {
    if (this._scrollFixedRaf) {
      cancelAnimationFrame(this._scrollFixedRaf);
      this._scrollFixedRaf = null;
    }
    getAppScrollContainer().removeEventListener('scroll', this.onScrollFixedTop);
    window.removeEventListener('resize', this.handleWindowResize);
    if (this._filterResizeObserver) {
      this._filterResizeObserver.disconnect();
      this._filterResizeObserver = null;
    }
  },
  components: {
    commonImportModal,
    commonLogModal,
    trackingInfoModal,
    carrierModal,
    ModifyMailingMethodModal,
    dropDownFilter,
    exportFieldsModal,
    dropDownDateTime,
    modifyWaybillNumberModal,
    allowCancellationOfOrdersModal,
    cancelOrderModal,
    addOrderTagsModal,
    orderAmountModificationModal,
    viewCustomizedInfoModal,
    cancelCustomizedProductOrdersModal,
    printComplianceLabelsModal,
    logisticsFeeReimbursementModal,
    orderProductModal
  }
};
</script>

<style lang="less" scoped>
.container_box {
  position: relative;

  .operation_box {
    .modify_styles span {
      display: flex;
      align-items: center;
    }

    .help_icon {
      margin-left: 5px;
      font-size: 20px;
      color: #fff;
      cursor: pointer;
    }
  }

  .table_box {
    .table_header_wrap {
      position: relative;
    }

    .table_header_box {
      background-color: #fff;
      border-right: 2px;
      overflow: hidden;
      height: 46px;
      line-height: 46px;
      padding: 0 20px;
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 12px;
      position: relative;

      .title {
        font-weight: 600;
        font-size: 15px;
        color: #000;
      }

      .select_table_box {
        position: absolute;
        top: 0px;
        left: 15px;
        z-index: 10;
      }
    }

    .fixed_table_header_box_style {
      position: fixed;
      background-color: #FFF;
      top: 102px;
      left: 0;
      z-index: 1000;
      width: 100%;
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    }

    .table_box_item {
      border-radius: 2px;
      border: 1px solid #dcdee2;
      margin-bottom: 15px;
      overflow: hidden;

      .table_content_header_box {
        width: 100%;
        background-color: #F7F7F7;
        height: 38px;
        padding-left: 16px;
        color: #666;
        display: flex;
        align-items: center;
        flex-wrap: wrap;

        /deep/ .ivu-tag {
          margin: 0px 10px 0 0;
        }
      }

      .table_content_box {
        border-top: 1px solid #dcdee2;
        width: 100%;
        background-color: #fff;
        box-sizing: border-box;
        display: flex;

        .orderGoods_box {
          width: 478px;
          border-right: 1px solid #dcdee2;

          .commodityInfo_box {
            border-bottom: 1px solid #dcdee2;
            padding: 12px 20px 12px 30px;
            display: flex;
            position: relative;

            .img_box {
              width: 70px;
              height: 70px;
              position: relative;
              cursor: pointer;

              img {
                display: inline-block;
                left: 50%;
                max-height: 100%;
                max-width: 100%;
                position: absolute;
                top: 50%;
                transform: translateY(-50%) translateX(-50%);
              }
            }

            .goods_box_btn {
              position: absolute;
              right: 10px;
              bottom: 10px;
              z-index: 10;
              cursor: pointer;
              color: #2D8CF0;
              text-decoration: underline;
            }

            &:last-child {
              border-bottom: none;
            }
          }
        }
      }

      .TiktokCBT_box {
        display: inline-block;
        padding: 0px 8px;
        border-radius: 15px;
        color: #2D8CF0;
        border: 1px solid #2D8CF0;
        margin-right: 5px;
        font-size: 12px;
      }
    }

    .no_classify {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-top: 80px;

      .txt {
        font-size: 15px;
        color: #666;
        margin-top: 15px;
      }
    }
  }

  .fixed_box_style {
    position: fixed;
    background-color: #F5F7F9;
    top: 50px;
    left: 0;
    z-index: 1000;
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

    /deep/ .ivu-tabs-bar {
      border-bottom: none;
      margin-bottom: 0;
      height: 52px;

      .ivu-tabs-nav .ivu-tabs-tab {
        padding: 16px !important;
      }

      .ivu-tabs-ink-bar {
        height: 3px !important;
      }
    }
  }
}

</style>
